import styled from 'styled-components';

export const LineUIStyled = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 75px 145px auto 30px;
  grid-column-gap: 5px;

  input {
    min-width: 20px;
  }
  
  input[type=number] {
    text-align: right;
  }
`